import { apiGet, apiPost } from "./apiClient";

const triggerDownload = (blob, fileName) => {
  const today = new Date().toISOString().slice(0, 10).replace(/-/g, "");
  const anchor = document.createElement("a");
  anchor.href = window.URL.createObjectURL(blob);
  anchor.download = `${fileName}_${today}.xlsx`;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(anchor.href);
};

const downloadExcel = async (url, fileName) => {
  try {
    const response = await apiGet(url);
    if (response.ok) {
      triggerDownload(await response.blob(), fileName);
      return { success: true, error: null };
    }
    return { success: false, error: "엑셀 다운로드에 실패했습니다." };
  } catch {
    return { success: false, error: "네트워크 오류가 발생했습니다." };
  }
};

const downloadExcelPost = async (url, body, fileName) => {
  try {
    const response = await apiPost(url, body);
    if (response.ok) {
      triggerDownload(await response.blob(), fileName);
      return { success: true, error: null };
    }
    return { success: false, error: "엑셀 다운로드에 실패했습니다." };
  } catch {
    return { success: false, error: "네트워크 오류가 발생했습니다." };
  }
};

// 고객
export const downloadCustExcel = () => downloadExcel("/admin/cust/excel", "고객목록");

// 가맹점
export const downloadStoreExcel = () => downloadExcel("/admin/store/excel", "가맹점목록");
export const downloadPendingStoreExcel = () => downloadExcel("/admin/store/excel/pending", "셀러등록가맹점목록");

// 상품
export const downloadProductExcel = () => downloadExcel("/admin/product/excel", "상품목록");
export const downloadSaleProductExcel = () => downloadExcel("/admin/product/sale/excel", "할인진행목록");
export const downloadSaleHistoryExcel = () => downloadExcel("/admin/product/sale/history/excel", "할인완료목록");
export const downloadNegoProductExcel = () => downloadExcel("/admin/product/nego/excel", "네고진행목록");
export const downloadNegoHistoryExcel = () => downloadExcel("/admin/product/nego/history/excel", "네고완료목록");

// 리뷰
export const downloadReviewExcel = () => downloadExcel("/admin/review/excel", "리뷰목록");
export const downloadReportedReviewExcel = () => downloadExcel("/admin/review/reportedReview/excel", "신고누적리뷰목록");

// CS
export const downloadQuestionExcel = () => downloadExcel("/admin/question/excel", "문의목록");
export const downloadReportExcel = () => downloadExcel("/admin/report/excel", "신고목록");

// 매출 (POST + 필터 조건)
export const downloadOrderExcel = (searchParams = null) => {
  const body = searchParams
    ? {
        startDate: searchParams.startDate || null,
        endDate: searchParams.endDate || null,
        creditType: searchParams.creditType || null,
        orderState: searchParams.orderState || null,
        searchType: searchParams.searchType || null,
        searchTerm: searchParams.searchTerm || null,
      }
    : null;
  return downloadExcelPost("/admin/order/excel", body, "매출목록");
};
